export default {"src":"/_next/static/media/TanThetaChart.ab0d03f3.svg","height":673,"width":806,"blurWidth":0,"blurHeight":0};